$(document).ready(function() {
  $(document).on('click', '.clients-momentum-task-bin-component .radio-buttons__option', function() {
    // Update radio button values back to financing section
    const momentumTaskId = $(this).attr('attr');
    const status = $(this).attr('value');
    updateMomentumTaskStatus(momentumTaskId, status);
  });

  function updateMomentumTaskStatus(id, status) {
    $.post('/components/clients/momentum_task_bin', { id: id, status: status }).done(function(data) {
      if (data.success && data.client_task_updated_count && data.client_task_updated_count > 0) {
        window.reloadClientTaskBinComponents();
      }
    });
  }
});
